import { type OriginAnalyticsAttributes } from '@atlassiansox/origin-tracing/types';

export enum GrowthPillar {
	FIND = 'FIND',
	BUY = 'BUY',
	USE = 'USE',
	PLATFORM = 'PLATFORM',
}

export type ExperimentCohortVariationControl = 'variation' | 'control' | 'not-enrolled';

/**
 * SELECTION - This is used to represent when the user is required to select an edition.
 */
export enum Edition {
	FREE_EDITION = 'FREE_EDITION',
	STANDARD_EDITION = 'STANDARD_EDITION',
	PREMIUM_EDITION = 'PREMIUM_EDITION',
	SELECTION = 'SELECTION',
}

export type FeatureId = 'edition-awareness' | 'admin-tools-upsell';

export type ExperimentMeta = {
	key: string;
	cohort: string;
	[other: string]: any;
};
export type ExperimentsMeta = ExperimentMeta[];

export type TouchpointContext = {
	featureId: FeatureId;
	experimentMeta?: ExperimentMeta[];
};

type TouchpointSharedAttributes = {
	growthPillar: GrowthPillar;
	experimentMeta?: ExperimentMeta;
};

// if a touchpoint intent has it's own dedicated type, we will exclude it here
interface TouchpointCommonAttributes extends TouchpointSharedAttributes {
	touchpointIntent: 'addPaymentDetails' | 'downgrade';
	currentProductEdition?: Edition;
	targetProductEdition?: Edition;
	href?: string;
}

type TouchpointCommonAnalyticsAttributes = TouchpointCommonAttributes &
	Partial<OriginAnalyticsAttributes>;

interface StartTrialTouchpointAttributes extends TouchpointSharedAttributes {
	touchpointIntent: 'startTrial';
	currentProductEdition: Edition;
	targetProductEdition: Edition;
	href: string;
}

type StartTrialTouchpointAnalyticsAttributes = StartTrialTouchpointAttributes &
	Partial<OriginAnalyticsAttributes>;

export type TouchpointAttributes =
	| TouchpointCommonAnalyticsAttributes
	| StartTrialTouchpointAnalyticsAttributes;
